import { render, staticRenderFns } from "./AsorItemModuleDatapoints.vue?vue&type=template&id=3c112bae"
import script from "./AsorItemModuleDatapoints.vue?vue&type=script&lang=js"
export * from "./AsorItemModuleDatapoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports